import { SET_RECEIPT_SETTINGS_DATA_LOADING, SET_RECEIPT_SETTINGS_DATA, CLEAR_RECEIPT_SETTINGS_DATA } from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const findReceiptSettings = (branchId, businessVerticalCode) => async (dispatch) => {
  try {
    dispatch({ type: SET_RECEIPT_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const queryParams = {
      companyId,
      branchId,
    };
    if (businessVerticalCode && businessVerticalCode !== 'DEFAULT') {
      queryParams.businessVerticalCode = businessVerticalCode;
    }
    if (!companyId || !branchId) {
      return false;
    }
    
    const res = await Axios.get('/api/dashboard/settings/find-receipt-settings-for-branch', {
      params: queryParams,
    });
    dispatch({
      type: SET_RECEIPT_SETTINGS_DATA,
      payload: res.data.data,
    });

    return true;
  } catch (error) {
    dispatch({
      type: SET_RECEIPT_SETTINGS_DATA,
      payload: [],
    });
    return false;
  }
}


export const updateReceiptSettings = (receiptSettings) => async (dispatch) => {
  try {
    dispatch({ type: SET_RECEIPT_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const requestBody = {
      ...receiptSettings.receiptSettingsData,
    };

    const queryParams = {
      companyId,
      branchId: receiptSettings.branchId,
    };
    if (receiptSettings.businessVerticalCode && receiptSettings.businessVerticalCode !== 'DEFAULT') {
      queryParams.businessVerticalCode = receiptSettings.businessVerticalCode;
    }

    const res = await Axios.post(`/api/dashboard/settings/update-receipt-settings`, requestBody, {
      params: queryParams,
    });
    dispatch({ type: SET_RECEIPT_SETTINGS_DATA_LOADING, payload: false });
    return true;
  } catch (err) {
    dispatch({ type: SET_RECEIPT_SETTINGS_DATA_LOADING, payload: false });
    return false;
  }
};